<script setup lang="ts">
withDefaults(
  defineProps<{
    formidableFormIds?: string[]
    hubspotFormsIds?: string[]
  }>(),
  {
    formidableFormIds: () => [],
    hubspotFormsIds: () => [],
  },
)

const formidableForms = ref([])
const hubspotForms = ref({})

defineExpose({
  formidableForms,
  hubspotForms,
})
</script>

<template>
  <div>
    <!-- Formidable forms -->
    <div>
      <div
        v-for="(formId, index) in formidableFormIds"
        :key="formId"
        :ref="(el) => (formidableForms[index] = el)"
        class="my-5"
      >
        <FormBuilder
          :form-id="formId"
          class="min-h-[550px]"
          field-extra-classes="mb-5"
          full-width-to-button
          success-message="Thank you for contacting us, one of our team will be in touch shortly."
        />
      </div>
    </div>

    <!-- HubSpot Forms -->
    <Teleport
      v-for="form in hubspotFormsIds"
      :key="form"
      :to="`#hs-form-${form}`"
    >
      <div class="lg:max-w-[80%] mx-auto my-10">
        <HSForm :form-id="form" success-message-classes="min-h-[550px]" />
      </div>
    </Teleport>
  </div>
</template>
